export function downloadEChartScrenshot(data: any) {
  const link = document.createElement('a')
  link.download = data.title
  link.href = data.data
  link.click()
}
